import { combineReducers } from 'redux';
import exportJobsFilters from 'store/reducers/export-jobs/get-export-jobs-filters';
import getExportJobs from 'store/reducers/export-jobs/get-export-jobs';
import exportJobsTableFilters from 'store/reducers/export-jobs/export-jobs-table-filters';

export default combineReducers({
  exportJobsFilters,
  getExportJobs,
  exportJobsTableFilters,
});
